export type { CalculatedConsumablesDemandProps } from './calculated-consumables-demand';
export * from './calculated-consumables-demand.routes';

export { default as CalculatedConsumablesDemand, default } from './calculated-consumables-demand';
